import { render, staticRenderFns } from "./SurveyCard.vue?vue&type=template&id=4797b494&scoped=true"
import script from "./SurveyCard.vue?vue&type=script&lang=js"
export * from "./SurveyCard.vue?vue&type=script&lang=js"
import style0 from "./SurveyCard.vue?vue&type=style&index=0&id=4797b494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4797b494",
  null
  
)

export default component.exports